import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LinkTarget } from 'src/app/types/link';

interface ProductGridItem {
  title: string;
  url: string;
  target: LinkTarget;
}

interface ProductGridInterface {
  title: string;
  items: ProductGridItem[];
  template: string;
}

@Component({
  selector: 'app-product-grid',
  templateUrl: './product-grid.component.html',
  styleUrls: ['./product-grid.component.scss'],
  host: { class: 'ion-content-stretched' },
})
export class ProductGridComponent {
  columnCount: number;

  @Input() node: ProductGridInterface;

  constructor(private router: Router) {}

  storeLink(item) {
    if (item.storeSlug) this.router.navigateByUrl('/shop/' + item.storeSlug);
  }

  ngOnInit() {
    if (this.node?.template)
      this.columnCount = 12 / parseInt(this.node.template.replace('grid-', ''));
  }
}
